"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Level = _interopRequireDefault(require("./Level"));
var _Condition = require("./Condition");
var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var validate = function validate(values) {
  var errors = {};
  function traverse(node, path) {
    if (node.conditions.length === 0) {
      errors[path] = 'At least one condition is required';
    }
    node.conditions.forEach(function (condition, index) {
      if (condition.conditions) {
        traverse(condition, "".concat(path, "[").concat(index, "].conditions"));
      } else if (!condition.column) {
        errors["".concat(path, "[").concat(index, "].column")] = 'Column is required';
      } else if (!condition.operator) {
        errors["".concat(path, "[").concat(index, "].operator")] = 'Operator is required';
      } else {
        var type = condition.column.type;
        var typeCondition = _Condition.allConditions[type].find(function (item) {
          return item.value === condition.operator;
        });
        if (typeCondition && typeCondition.validate) {
          (0, _mapValues2["default"])(typeCondition.validate(condition.value), function (value, key) {
            errors["".concat(path, "[").concat(index, "].").concat(key)] = value;
          });
        }
      }
    });
  }
  traverse(values, 'conditions');
  return errors;
};
exports.validate = validate;
var Component = function Component(props) {
  var values = props.values,
    addFilter = props.addFilter,
    removeFilter = props.removeFilter;
  return !values ? /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-default btn-sm",
    onClick: addFilter
  }, "Add filter") : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: '1em'
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-danger btn-sm",
    onClick: removeFilter
  }, "Remove all filters")), /*#__PURE__*/_react["default"].createElement(_Level["default"], {
    path: "",
    values: values
  }));
};
Component.propTypes = {
  updateFilter: _propTypes["default"].func,
  closeModal: _propTypes["default"].func,
  initialValues: _propTypes["default"].object,
  values: _propTypes["default"].object,
  addFilter: _propTypes["default"].func,
  removeFilter: _propTypes["default"].func
};
var _default = Component;
exports["default"] = _default;